import { render, staticRenderFns } from "./NoTemplateMessage.vue?vue&type=template&id=5c85e506&scoped=true&"
import script from "./NoTemplateMessage.vue?vue&type=script&lang=js&"
export * from "./NoTemplateMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoTemplateMessage.vue?vue&type=style&index=0&id=5c85e506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85e506",
  null
  
)

export default component.exports